import { Typography } from '@mui/material';
import React from 'react';

interface IAuditCardTextValueProps {
	value: string;
}

const AuditCardTextValue: React.FC<IAuditCardTextValueProps> = ({ value }) => (
	<Typography
		variant="subtitle1"
		display="inline"
		sx={{
			wordBreak: 'break-word'
		}}
	>
		{value}
	</Typography>
);

export default AuditCardTextValue;
